// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"18013609","213":"c4bc904c","640":"bc9f846f","867":"d68899d4","879":"be0ba874"}[chunkId] + ".chunk.js";
};